import React, { useEffect } from "react";
import { NextPage } from "next";
import { Layout, message, Typography } from "antd";
import { Header } from "@dewo/app/containers/navigation/header/Header";
import { NotificationList } from "@dewo/app/containers/notification/NotificationList";
import { useUpdateUser } from "@dewo/app/containers/user/hooks";
import { useRouter } from "next/router";
import { useAmplitude } from "@dewo/app/util/analytics/AmplitudeContext";
import { useAuthContext } from "@dewo/app/contexts/AuthContext";
import _ from "lodash";

const Page: NextPage = () => {
  const updateUser = useUpdateUser();
  const { user } = useAuthContext();
  const router = useRouter();
  const amp = useAmplitude();

  useEffect(() => {
    if (!!router.query["unsubscribe-dm"] && user) {
      amp.logEvent("Unsubscribe from Discord DM notifications");
      updateUser({ openTasksNotifications: false }).then(() =>
        message.success("Successfully unsubscribed!")
      );
      router.replace({ query: _.omit(router.query, "unsubscribe-dm") });
    }
  }, [amp, router, updateUser, user]);

  return (
    <Layout.Content style={{ overflowY: "auto" }}>
      <Header />
      <div className="mx-auto max-w-sm w-full" style={{ padding: 8 }}>
        <Typography.Title style={{ textAlign: "center" }}>
          Inbox
        </Typography.Title>
        <NotificationList />
      </div>
    </Layout.Content>
  );
};

export default Page;
